import { Component, Input } from '@angular/core';

@Component({
  selector: 'dp-field-error',
  templateUrl: './dp-field-error.component.html',
  styleUrls: ['./dp-field-error.component.scss']
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class DpFieldError {

  @Input() formField;
  defaultMessage = 'This is required field';
  messages = [this.defaultMessage];

  @Input('error')
  set errorMessages(value) {
    if (value) {
      this.messages = value;
    }
  }
}
